import { SourceObjectCell, type SourceObjectCellProps, type SourceObjectDropdownProps } from './SourceObjectCell'
import { type RefSelectProps, Select } from 'antd'
import { useProducts } from '@/api/useProducts'
import { useAddCellMapping } from './useAddCellMapping'
import { forwardRef } from 'react'
import { MappingDropdown } from '../MappingDropdown'

export const ProductCell = (
  props: SourceObjectCellProps<Gravitate.Ebol['details'][0] & { parent?: Gravitate.Ebol }>
) => <SourceObjectCell {...props} dropdown={ProductCellDropdown} itemDisplayLimit={3} />

const ProductCellDropdown = forwardRef<RefSelectProps, SourceObjectDropdownProps>((props, ref) => {
  const { useProductNamesQuery } = useProducts()
  const { data, isFetching, isPending } = useProductNamesQuery()
  const onChange = useAddCellMapping('product', props.sourceSystem, props.value?.source_id)
  return (
    <MappingDropdown
      loading={isFetching || isPending}
      title='Add Product Mapping'
      subtitle='Select product to map to eBOL product'
      style={{ minWidth: '300px' }}
      optionFilterProp='label'
      ref={ref}
      onChange={onChange}
    >
      {[...new Set<string>(data ?? [])]
        .filter((x) => !props.value?.id_names?.some(({ name }) => name === x))
        .sort()
        .map((x: string) => (
          <Select.Option key={x} value={x} label={x}>
            {x}
          </Select.Option>
        ))}
    </MappingDropdown>
  )
})
